import React from "react";
// import Arsenal from "../assets/Arsenal.png";
import SageverseBg from "../assets/sageverseBg.png";
import SonarwalletBg from "../assets/SonarwalletBg.png";
import UpworkBg from "../assets/UpworkBg.png";
import KolnetBg from "../assets/KolnetBg.png";
import KamelpayBg from "../assets/KamelpayBg.png";
import NitroBg from "../assets/NItroBg.png";
import CText from "../Components/CText";
import { Col, Row } from "reactstrap";

function Projects() {
  const handleOnClick = (websiteLink) => {
    window.open(`${websiteLink}`, "_blank");
  };

  return (
    <div className="projectsSection">
      <CText
        className="headingText"
        fontSize="2.5rem"
        text={
          <p className="d-flex align-items-center justify-content-center">
            Highlighted Projects
          </p>
        }
      />
      <CText
        className="subHeading"
        fontSize="1.2rem"
        text={
          <p className="d-flex align-items-center justify-content-center">
            Explore a Handpicked Collection of Highlighted Websites from My
            Portfolio, Showcasing the Projects and Companies I've Had the
            Pleasure of Working with.{" "}
          </p>
        }
      />
      {/* <div className="projectsContainer"> */}
      <Row className="mb-5" xl="3" lg="2" xs="1">
        <Col className="d-flex justify-content-center mb-5">
          <div className={`box `}>
            <div
              style={{ backgroundImage: `url(${SageverseBg})` }}
              className="box-content"
            >
              <img
                src={SageverseBg}
                alt="Background"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
            <CText
              className=""
              containerClass="textAnimation"
              fontSize="2.3rem"
              text={
                <p className="d-flex align-items-center justify-content-center cw">
                  Sageverse{" "}
                </p>
              }
            />
            <button
              className="box-button"
              onClick={() => handleOnClick("https://www.sageverse.xyz/")}
            >
              Visit Website
            </button>
          </div>
        </Col>
        <Col className="d-flex justify-content-center mb-5">
          <div class="box">
            <div
              style={{ backgroundImage: `url(${SonarwalletBg})` }}
              class="box-content"
            ></div>
            <CText
              className=""
              containerClass="textAnimation"
              fontSize="2.3rem"
              text={
                <p className="d-flex align-items-center justify-content-center cw">
                  Sonar Wallet
                </p>
              }
            />
            <button
              onClick={() =>
                handleOnClick("https://www.sonarplatform.io/wallet")
              }
              class="box-button"
            >
              Visit Website
            </button>
          </div>
        </Col>
        <Col className="d-flex justify-content-center mb-5">
          <div class="box">
            <div
              style={{ backgroundImage: `url(${KolnetBg})` }}
              class="box-content"
            ></div>
            <CText
              className=""
              containerClass="textAnimation"
              fontSize="2.3rem"
              text={
                <p className="d-flex align-items-center justify-content-center cw">
                  Kolnet{" "}
                </p>
              }
            />
            <button
              onClick={() => handleOnClick("https://kolnet.io/")}
              class="box-button"
            >
              Visit Website
            </button>
          </div>
        </Col>
        <Col className="d-flex justify-content-center mb-5">
          <div class="box">
            <div
              style={{ backgroundImage: `url(${NitroBg})` }}
              class="box-content"
            ></div>
            <CText
              className=""
              containerClass="textAnimation"
              fontSize="2.3rem"
              text={
                <p className="d-flex align-items-center justify-content-center cw">
                  Nitro Superstaking
                </p>
              }
            />

            <button
              onClick={() => handleOnClick("https://superstaking.io/")}
              class="box-button"
            >
              Visit Website
            </button>
          </div>
        </Col>
        <Col className="d-flex justify-content-center mb-5">
          <div class="box">
            <div
              style={{ backgroundImage: `url(${KamelpayBg})` }}
              class="box-content"
            ></div>
            <CText
              className=""
              containerClass="textAnimation"
              fontSize="2.3rem"
              text={
                <p className="d-flex align-items-center justify-content-center cw">
                  Kamelpay{" "}
                </p>
              }
            />
            <button
              onClick={() => handleOnClick("https://kamelpay.com/")}
              class="box-button"
            >
              Visit Website
            </button>
          </div>
        </Col>

        <Col className="d-flex justify-content-center mb-5">
          <div class="box">
            <div
              style={{ backgroundImage: `url(${UpworkBg})` }}
              class="box-content"
            ></div>
            <CText
              className=""
              containerClass="textAnimation"
              fontSize="2.3rem"
              text={
                <p className="d-flex align-items-center justify-content-center cw">
                  Upwork Clone{" "}
                </p>
              }
            />
            <button
              onClick={() =>
                handleOnClick("https://upwork-clone-4cf4e.web.app/")
              }
              class="box-button"
            >
              Visit Website
            </button>
          </div>
        </Col>
      </Row>
    </div>
    // </div>
  );
}

export default Projects;
